import { setupDate } from '~/helpers/fields-description';
import { ip } from '~/helpers/network-fields-description';
import { FieldObject } from '~/interfaces/field.interface';
import { Gateway } from '~/models/gateways/gateway.model';

export class MFH extends Gateway {
    MAX_TIME_BEFORE_CONSIDERED_DISCONNECTED = 24 * 3600;

    hasOperationReset = false;
    hasOperationImportData = false;
    hasOperationMainloop = false;

    portal = 'https://portal-m2m.telekom.de/m2m-customer-portal/user/simcard/detail';
    specFieldsOrder = [
        'macAddress',
        'oemSerial',
        'iccId',
        'type',
        'mcuFirmware',
        'lastUpdate',
        'setupDate',
        'deutschTelekomPortalLink',
    ];

    get fieldRoom() {
        return undefined;
    }
    get fieldName() {
        return undefined;
    }
    get fieldHwVersion() {
        return undefined;
    }
    get fieldLastSetup() {
        return undefined;
    }
    get fieldLastStatusStored() {
        return undefined;
    }
    get fieldUptime() {
        return undefined;
    }
    get fieldSetupDate() {
        return setupDate(this.date_setup, 'bold');
    }
    get fieldOemSerial() {
        return { key: 'oemSerial', value: this.oem_serial };
    }
    get fieldIccId() {
        return { key: 'iccId', value: this.iccid, type: 'string' };
    }
    get fieldMcuFirmware() {
        return { key: 'mcuFirmware', value: this.firmware, class: 'bold' };
    }
    get fieldDeutschTelekomPortalLink() {
        return {
            key: 'deutschTelekomPortalLink',
            value: `${this.portal}/${this.iccid}`,
            type: 'externalLink',
            link: `${this.portal}/${this.iccid}`,
        };
    }

    getNetworkFields(): FieldObject[] {
        let fields = [] as FieldObject[];
        if (!this.network) {
            fields.push({ key: 'No Info', value: '' });
        } else {
            if (this.network.server_node && this.network.server_node.disconnection) {
                const currentDay = new Date().toJSON().slice(0, 10);
                const isDisconnectionDatePriorToToday =
                    this.network.server_node.disconnection * 1000 < Date.parse(currentDay);
                fields = fields.concat([
                    ip(this.network.ip),
                    {
                        key: 'Last Disconnection',
                        value: this.network.server_node.disconnection,
                        type: 'date',
                        class: isDisconnectionDatePriorToToday ? 'error--text' : '',
                    },
                ]);
            }
        }
        return fields;
    }
}

